/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Carrier_Update_FailedInputs */

const en_orders_carrier_update_failed = /** @type {(inputs: Orders_Carrier_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update carrier`)
};

const es_orders_carrier_update_failed = /** @type {(inputs: Orders_Carrier_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo actualizar el transportista`)
};

/**
* | output |
* | --- |
* | "Failed to update carrier" |
*
* @param {Orders_Carrier_Update_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_carrier_update_failed = /** @type {((inputs?: Orders_Carrier_Update_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Carrier_Update_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_carrier_update_failed(inputs)
	return es_orders_carrier_update_failed(inputs)
});